module.exports = __webpack_public_path__ + "static/media/Screen Shot 2021-02-18 at 5_1613660505585.8e385f6e.59";